import { UiMessageProps, MessageSeverity } from "../../models/components/field-message.model";
import { AppointmentsService } from "../../services/appointments/appointments.service";
import { useTranslation } from "react-i18next";
import UiMessage from "../../components/message/Message.component";
import { useEngagementsCompleted } from "../../hooks/useEngagementsCompleted";

const PastAppointments = () => {
	const { t } = useTranslation("common");

	const engagementsQuery = useEngagementsCompleted();

	const hasData = () => {
		let result = false;
		if (
			engagementsQuery.data &&
			engagementsQuery.data?.filter(
				(x) => new Date(x.createdOn).getTime() < new Date().getTime()
			).length > 0
		) {
			result = true;
		}
		return result;
	};

	const setMessage = () => {
		let result: UiMessageProps = {
			severity: MessageSeverity.LOADING,
			label: "UI_COMPONENTS.MESSAGE.MSG.LOADING",
		};
		if (engagementsQuery.isError) {
			result = {
				severity: MessageSeverity.DANGER,
				label: "UI_COMPONENTS.MESSAGE.MSG.ERROR",
			};
		} else if (!engagementsQuery.isLoading && !engagementsQuery.isError && !hasData()) {
			result = {
				severity: MessageSeverity.INFO,
				label: "APPOINTMENTS.EMPTY_COMPLETED",
			};
		}
		return result;
	};

	return (
		<div className="appointment-list">
			{engagementsQuery.isLoading || engagementsQuery.isError || !hasData() ? (
				<UiMessage
					severity={setMessage().severity}
					label={setMessage().label}
				/>
			) : (
				engagementsQuery.data
					.filter((x) => new Date(x.createdOn).getTime() < new Date().getTime())
					.sort(
						(a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
					)
					.map((x) => (
						<div
							key={x.id}
							className="appointment"
						>
							<div className="appointment__info">
								<span className="appointment__info__type">
									{t(`ENUMS.ENGAGEMENT_DETAILS.${x.details}`)}
								</span>
							</div>
							<div className="appointment__date">
								{AppointmentsService.templateDatetime(x.createdOn.toString(), {
									weekday: "long",
									day: "2-digit",
									month: "long",
									year: "numeric",
									hour: "2-digit",
									minute: "2-digit",
									timeZoneName: "shortGeneric",
								})}
							</div>
						</div>
					))
			)}
		</div>
	);
};
export default PastAppointments;
